import { useState, useEffect } from 'react';

/**
 * Hook to track first-time visits to features
 * @param {string} featureName - Unique identifier for the feature
 * @returns {object} - Object containing isFirstVisit boolean and setVisited function
 */
export function useFirstVisit(featureName) {
  const [isFirstVisit, setIsFirstVisit] = useState(false);
  
  useEffect(() => {
    const key = `visited_${featureName}`;
    const visited = localStorage.getItem(key);
    
    // If not visited, it's the first visit
    setIsFirstVisit(!visited);
  }, [featureName]);
  
  const setVisited = () => {
    const key = `visited_${featureName}`;
    localStorage.setItem(key, 'true');
    setIsFirstVisit(false);
  };
  
  return { isFirstVisit, setVisited };
}